import { render, staticRenderFns } from "./IssueNote.vue?vue&type=template&id=0385b77b&scoped=true"
import script from "./IssueNote.vue?vue&type=script&lang=js"
export * from "./IssueNote.vue?vue&type=script&lang=js"
import style0 from "./IssueNote.vue?vue&type=style&index=0&id=0385b77b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0385b77b",
  null
  
)

export default component.exports